import React, { useEffect, useState } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import {
  sortCaret,
  headerSortingClasses,
  PleaseWaitMessage,
  NoRecordsFoundMessage,
} from "../../../_metronic/_helpers";
import { useDispatch, useSelector } from "react-redux";

import { useHistory } from "react-router-dom";
import {
  sizePerPageList,
  showSuccessDialog,
  showErrorDialog,
  activeFormatter,
  showConfirmDialog,
  formatDate,
  lockedFormatter,
  showDeleteDialog,
  checkPermision,
} from "../../utility";
import { toAbsoluteUrl } from "../../../_metronic/_helpers";
import LoadingFetchData from "../../utility/LoadingFetchData";
import SVG from "react-inlinesvg";
import { Button, Col, Row } from "react-bootstrap";
import { editParty, removeParty, selectPermissionParty } from "./partySlice";

export const PartyTable = ({
  data,
  page,
  sizePerPage,
  sortField,
  sortOrder,
  onTableChange,
  totalSize,
  loading,
  handleSearch,
}) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const permission = useSelector(selectPermissionParty);

  const [selectedRows, setSelectedRows] = useState([]);

  useEffect(() => {
    // Add number
    const pageBefore = sizePerPage * (page - 1);
    const initData = data.map((item, index) => {
      return {
        ...item,
        no: index + 1 + pageBefore,
        office_name:
          item.offices === null
            ? ""
            : item.offices.map((item) => item.office_name).join(","),
        clients_name:
          item.clients === null
            ? ""
            : item.clients.map((item) => item.client_name).join(","),
      };
    });
    setTableData(initData);
  }, [data, sizePerPage, page]);

  const [tableData, setTableData] = useState(data);

  const handleDelete = async (e, row) => {
    const params = [{ party_id: `${row.party_id}` }];
    const action = await showDeleteDialog(`Are you sure you want to delete?`);
    if (action.isConfirmed) {
      try {
        const response = await dispatch(removeParty({ data: params }));
        if (response.payload.data.status === 200) {
          const action = await showSuccessDialog(response.payload.data.message);
          await handleSearch();
        } else {
          showErrorDialog(response.payload.data.message);
        }
      } catch (error) {
        console.log(error);
      }
    }
  };

  const actionFormatter = (e, row, rowIndex, formatExtraData) => {
    return (
      <>
        <div>
          {/* <OverlayTrigger
            overlay={<Tooltip id="products-edit-tooltip">View</Tooltip>}
          >
            <a
              className="btn btn-icon btn-primary btn-hover-primary btn-sm mr-3 mb-1"
              onClick={() => {
                history.push(
                  `/administration/office-management/view/${row.office_id}`
                );
              }}
            >
              <span className="svg-icon svg-icon-md svg-icon-light">
                <SVG
                  src={toAbsoluteUrl( "/media/svg/icons/New/Search.svg")}
                />
              </span>
            </a>
          </OverlayTrigger> */}

          {checkPermision(permission, "UPDATE") && (
            <>
              {row.is_enable === "Y" && (
                <OverlayTrigger
                  overlay={<Tooltip id="products-edit-tooltip">Edit</Tooltip>}
                >
                  <div
                    className="btn btn-icon btn-primary btn-hover-primary btn-sm mr-3"
                    onClick={() => {
                      history.push(`/master/party-master/edit/${row.party_id}`);
                    }}
                  >
                    <span className="svg-icon svg-icon-md svg-icon-light">
                      <SVG
                        src={toAbsoluteUrl("/media/svg/icons/New/edit.svg")}
                      />
                    </span>
                  </div>
                </OverlayTrigger>
              )}
            </>
          )}

          {checkPermision(permission, "DELETE") && (
            <>
              {row.is_enable === "Y" && (
                <OverlayTrigger
                  overlay={
                    <Tooltip id="products-delete-tooltip">Delete</Tooltip>
                  }
                >
                  <div
                    className="btn btn-icon btn-primary btn-hover-primary btn-sm mr-3"
                   onClick={(e) =>
                      handleDelete(e, row )
                    }
                  >
                    <span className="svg-icon svg-icon-md svg-icon-light">
                      <SVG
                        src={toAbsoluteUrl("/media/svg/icons/New/delete.svg")}
                      />
                    </span>
                  </div>
                </OverlayTrigger>
              )}
            </>
          )}

          {checkPermision(permission, "CREATE") && (
            <>
              {row.is_enable === "Y" && (
                <OverlayTrigger
                  overlay={
                    <Tooltip id="products-edit-tooltip">Disabled</Tooltip>
                  }
                >
                  <div
                    className="btn btn-icon btn-primary btn-hover-primary btn-sm mr-3"
                    onClick={() => handleDisabled(e, row, rowIndex)}
                  >
                    <span className="svg-icon svg-icon-md svg-icon-light">
                      <SVG
                        src={toAbsoluteUrl(
                          "/media/svg/icons/New/eye-slash.svg"
                        )}
                      />
                    </span>
                  </div>
                </OverlayTrigger>
              )}
              {row.is_enable === "N" && (
                <OverlayTrigger
                  overlay={
                    <Tooltip id="products-edit-tooltip">Enabled</Tooltip>
                  }
                >
                  <div
                    className="btn btn-icon btn-primary btn-hover-primary btn-sm mr-3"
                    onClick={() => handleEnable(e, row, rowIndex)}
                  >
                    <span className="svg-icon svg-icon-md svg-icon-light">
                      <SVG
                        src={toAbsoluteUrl("/media/svg/icons/New/eye.svg")}
                      />
                    </span>
                  </div>
                </OverlayTrigger>
              )}
            </>
          )}
        </div>
      </>
    );
  };

  const handleDisabled = async (e, row, rowIndex) => {
    const params = {
      party_id: row.party_id,
      is_enable: "N",
    };
    console.log(params);

    const action = await showConfirmDialog(`Are you sure want to disabled?`);
    if (action.isConfirmed) {
      try {
        const response = await dispatch(editParty(params));
        if (response.payload.status === 200) {
          const action = await showSuccessDialog(response.payload.message);
          await handleSearch();
        } else {
          showErrorDialog(response.payload.data.message);
        }
      } catch (error) {
        console.log(error);
      }
    }
  };
  const handleEnable = async (e, row, rowIndex) => {
    const params = {
      party_id: row.party_id,
      is_enable: "Y",
    };
    console.log(params);

    const action = await showConfirmDialog(`Are you sure want to enable?`);
    if (action.isConfirmed) {
      try {
        const response = await dispatch(editParty(params));
        if (response.payload.status === 200) {
          const action = await showSuccessDialog(response.payload.message);
          await handleSearch();
        } else {
          showErrorDialog(response.payload.data.message);
        }
      } catch (error) {
        console.log(error);
      }
    }
  };
  const columns = [
    {
      text: "No",
      dataField: "no",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "60px" },
    },
    {
      text: "Code",
      dataField: "party_code",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
    },
    {
      text: "Name",
      dataField: "party_name",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
    },
    {
      text: "Associated Office",
      dataField: "office_name",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
    },

    {
      text: "Associated Clients",
      dataField: "clients_name",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "200px" },

    },
    {
      dataField: "actions",
      text: "Actions",
      formatter: actionFormatter,
      style: { minWidth: "200px" },

    },
  ];

  const options = {
    page: page < 0 ? 1 : page,
    sizePerPage: sizePerPage,
    showTotal: true,
    totalSize: totalSize,
    sizePerPageList: sizePerPageList(totalSize),
  };

  return (
    <>
      <BootstrapTable
        remote
        wrapperClasses="table-responsive"
        classes="table table-head-custom table-vertical-center overflow-hidden rounded mt-4"
        bootstrap4
        
        keyField="party_id"
        data={tableData}
        columns={columns}
        pagination={paginationFactory(options)}
        onTableChange={onTableChange}
        sort={{ dataField: sortField, order: sortOrder }}
        hover
        striped
      >
        <PleaseWaitMessage entities={loading ? null : tableData} />
        <NoRecordsFoundMessage entities={loading ? null : tableData} />
      </BootstrapTable>
      {/* Footer */}
    </>
  );
};
